import { Mic, Sparkles, ListChecks } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
  { icon: Mic, n: "01", title: "Record", text: "Press record in class, in a meeting or while you think out loud. That's your only job." },
  { icon: Sparkles, n: "02", title: "Tilla' listens & understands", text: "The AI picks out what matters: key ideas, deadlines, things you promised to do." },
  { icon: ListChecks, n: "03", title: "Everything's organized", text: "You get clean notes, a short summary, tasks and reminders — ready to search later." },
];

export const HowItWorks = () => (
  <section id="how" data-testid="how-it-works-section" className="border-t border-white/5 py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHead eyebrow="How it works" title="From voice to organized in three steps." sub="No typing after the lecture. No rewriting messy notes at midnight." />
      <div className="grid gap-6 md:grid-cols-3">
        {STEPS.map(({ icon: Icon, n, title, text }, i) => (
          <Reveal key={n} delay={i * 0.1}>
            <div data-testid={`how-step-${n}`} className="group h-full rounded-2xl border border-white/10 bg-card p-8 transition-transform duration-300 hover:-translate-y-1">
              <div className="mb-10 flex items-center justify-between">
                <Icon className="h-6 w-6 text-cyan" />
                <span className="font-mono text-sm text-muted-foreground">{n}</span>
              </div>
              <h3 className="font-display text-xl font-semibold">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
